module.exports = __webpack_public_path__ + "media/images/gallery/constellations/figure_layer_on-d4690179ea6522fca086985be3fc2539.png";